import Box from '@/common/components/Box'
import Skeleton from '@/common/components/Skeleton'

const MaintenanceWorkflowExecutionEntryUpdateLoading = () => {
  return (
    <div className="flex-1 flex flex-col gap-4">
      <Box className="p-4 flex flex-col gap-4">
        <Skeleton className="bg-white-100 h-12 w-full" />

        <div className="flex flex-col gap-3">
          {[1, 2].map((index) => (
            <Box key={index} className="flex flex-col gap-4 p-4 rounded-lg">
              <div className="flex items-center gap-4">
                <Skeleton className="w-32 h-8" />

                <div className="flex flex-col gap-1 flex-1">
                  <Skeleton className="w-48 h-6" />
                  <Skeleton className="w-60 h-4" />
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <Skeleton className="w-20 h-4" />
                <Skeleton className="bg-white-100 h-24 w-full" />
              </div>

              <div className="flex flex-col gap-2">
                <Skeleton className="w-20 h-4" />
                <Skeleton className="bg-white-100 h-24 w-full" />
              </div>
            </Box>
          ))}
        </div>
      </Box>
    </div>
  )
}

export default MaintenanceWorkflowExecutionEntryUpdateLoading
